module.exports = __webpack_public_path__ + "static/img/2.cb99f4ec.png";